import { Country } from 'shared/config/internalization';

export const getCountryByUrl = (url: string) => {
  if (url.startsWith('/kz/zaimy/')) {
    return Country.Kazakhstan;
  }

  return Country.Russia;
};
